import { render, staticRenderFns } from "./SOVallDetailedIndia.vue?vue&type=template&id=4e8d9ded&scoped=true"
import script from "./SOVallDetailedIndia.vue?vue&type=script&lang=js"
export * from "./SOVallDetailedIndia.vue?vue&type=script&lang=js"
import style0 from "./SOVallDetailedIndia.vue?vue&type=style&index=0&id=4e8d9ded&prod&lang=css"
import style1 from "./SOVallDetailedIndia.vue?vue&type=style&index=1&id=4e8d9ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8d9ded",
  null
  
)

export default component.exports